module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio39-d03c11c51b391593f102fd8e8b2d5aa6.m4a";